import { Alert } from 'antd'
import noop from 'lodash/noop'
import queryString from 'query-string'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import api from '../../api'
import { toPath } from '../../routes'

const UNMATCHED_URL = queryString.stringifyUrl({
  url: toPath.transmissions(),
  query: { matched: 'false' },
})

export default function UnmatchedCount() {
  const [unmatchedCount, setUnmatchedCount] = useState()
  useEffect(() => {
    api.transmissions
      .list({ perPage: 1, matched: 'false' })
      .then(({ headers }) => setUnmatchedCount(Number(headers.get('X-Total'))))
      .catch(noop)
  }, [])
  if (!unmatchedCount) return null
  return (
    <Link to={UNMATCHED_URL}>
      <Alert
        message={`You have ${unmatchedCount} transmission${
          unmatchedCount > 1 ? 's' : ''
        } needing matching. Click here.`}
        type="warning"
        showIcon
        closable
      />
    </Link>
  )
}
